import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
var _effectorFileName = "/builds/gmini/front-common/src/SeoEventManager/SeoEventManager.ts";
import "core-js/modules/es.object.define-property.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

export var SeoEventManager = /*#__PURE__*/function () {
  function SeoEventManager(props) {
    _classCallCheck(this, SeoEventManager);

    _defineProperty(this, "envName", void 0);

    _defineProperty(this, "seoEnabled", void 0);

    this.envName = props.envName;
    this.seoEnabled = props.seoEnabled;
  }

  _createClass(SeoEventManager, [{
    key: "push",
    value: function push(options) {
      var serviceEvent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (!this.seoEnabled) {
        return;
      }

      if (serviceEvent) {
        window.dataLayer.push({
          event: options.event,
          payload: _objectSpread(_objectSpread({}, options.payload), {}, {
            envName: this.envName
          })
        });
        return;
      }

      window.dataLayer.push(options); // Мы ресетим dataLayer, чтобы избежать мержа payload между разными эвентами
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore

      window.dataLayer.push(function () {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        // eslint-disable-next-line no-invalid-this
        this.reset();
      });
    }
  }]);

  return SeoEventManager;
}();